import {
  getRequest,
  postRequest,
  putRequest,
  deleteRequest,
  patchRequest,
} from "../api/request";

export const getAllSectionBrands = () => {
  return getRequest(`/brands`);
};

export const getSectionBrands = (section) => {
  return getRequest(`/brands/${section}`);
};

export const addSectionBrand = (section, data) => {
  return postRequest(`/brands/${section}`, { name: data });
};

export const updateBrand = (section, brandId, newValue) => {
  return putRequest(`/brands/${section}/${brandId}`, { name: newValue });
};

export const deleteBrand = (section, brandId) => {
  return deleteRequest(`/brands/${section}/${brandId}`);
};

export const updateBrandSettings = (section, brandId, settings) => {
  return putRequest(`/brands/setting/${section}/${brandId}`, settings);
};
